import { useState, useEffect } from "react";
import AnimatedSection from '../../../components/base/AnimatedSection';

const WA_PACK =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20un%20Pack%20Equipo%20para%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

function PriceRow({ label, value, sub }: { label: string; value: string; sub?: string }) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
      <span className="text-sm text-gray-600">{label}</span>
      <div className="text-right">
        <span className="font-bold text-gray-900 text-sm">{value}</span>
        {sub && <p className="text-xs text-teal-600 font-medium">{sub}</p>}
      </div>
    </div>
  );
}

export default function EntradasYPacks() {
  const [viewers, setViewers] = useState(
    () => Math.floor(Math.random() * 5) + 3
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(Math.floor(Math.random() * 5) + 3);
    }, 4000 + Math.random() * 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-20 bg-teal-500">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <AnimatedSection animation="fadeUp">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 text-center">
              Entradas y packs
            </h2>
            <p className="text-white/80 text-center mb-8 text-lg">
              Elegí el módulo que más te conviene o llevate los dos
            </p>
          </AnimatedSection>

          {/* BLOQUE URGENCIA CUPOS */}
          <AnimatedSection animation="fadeUp" delay={0}>
            <div className="bg-red-900 border-2 border-red-500 rounded-2xl p-6 mb-10 flex flex-col md:flex-row items-center justify-between gap-6 shadow-2xl">
              <div className="flex items-center gap-5">
                <div className="text-center">
                  <p className="text-white/70 text-xs font-semibold uppercase tracking-widest mb-1">⚠️ Cupos disponibles</p>
                  <span className="text-8xl font-black text-red-400 leading-none block animate-pulse">9</span>
                  <p className="text-white/60 text-xs mt-1">de 40 totales</p>
                </div>
                <div>
                  <p className="text-white font-bold text-xl mb-1">¡Casi agotado!</p>
                  <p className="text-white/80 text-sm mb-3">El 62% de los cupos ya fue reservado.<br />No te quedes sin el tuyo.</p>
                  <div className="w-48 bg-white/20 rounded-full h-3 overflow-hidden">
                    <div
                      className="h-full bg-gradient-to-r from-red-500 to-orange-400 rounded-full"
                      style={{ width: '62.5%' }}
                    />
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="relative w-3 h-3 flex items-center justify-center">
                  <div className="w-3 h-3 bg-red-400 rounded-full animate-pulse" />
                  <div className="absolute w-3 h-3 bg-red-400 rounded-full animate-ping" />
                </div>
                <p className="text-white/80 text-sm font-medium">
                  <span className="font-bold text-white">{viewers}</span> personas viendo ahora
                </p>
              </div>
            </div>
          </AnimatedSection>

          {/* ENTRADAS INDIVIDUALES */}
          <AnimatedSection animation="fadeUp" delay={0}>
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
              <span className="bg-white/20 rounded-full w-8 h-8 flex items-center justify-center text-sm">1</span>
              Entradas Individuales
            </h3>
          </AnimatedSection>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {/* Módulo 1 */}
            <AnimatedSection animation="fadeUp" delay={0}>
              <div className="bg-white rounded-xl p-7 h-full flex flex-col">
                <div className="flex items-center gap-2 mb-4 flex-wrap">
                  <div className="bg-teal-600 text-white text-xs font-bold py-1 px-3 rounded-full inline-block">
                    MÓDULO 1
                  </div>
                  <span className="text-xs text-teal-600 font-semibold">de 9 a 13hs</span>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-1">IA Aplicada a tu Empresa</h4>
                <p className="text-xs text-gray-500 mb-5">Incluye desayuno</p>
                <div className="mt-auto space-y-1">
                  <div className="bg-gradient-to-r from-teal-500 to-teal-400 rounded-lg p-4 mb-3">
                    <p className="text-2xl font-black text-white">ARS 110.000</p>
                  </div>
                  <PriceRow label="Transferencia (5% off)" value="ARS 104.500" />
                </div>
              </div>
            </AnimatedSection>

            {/* Módulo 2 */}
            <AnimatedSection animation="fadeUp" delay={150}>
              <div className="bg-white rounded-xl p-7 h-full flex flex-col">
                <div className="flex items-center gap-2 mb-4 flex-wrap">
                  <div className="bg-red-700 text-white text-xs font-bold py-1 px-3 rounded-full inline-block">
                    MÓDULO 2
                  </div>
                  <span className="text-xs text-red-700 font-semibold">de 14 a 17hs</span>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-1">Método de Venta con IA</h4>
                <p className="text-xs text-gray-500 mb-5">&nbsp;</p>
                <div className="mt-auto space-y-1">
                  <div className="bg-gradient-to-r from-red-700 to-red-600 rounded-lg p-4 mb-3">
                    <p className="text-2xl font-black text-white">ARS 85.000</p>
                  </div>
                  <PriceRow label="Transferencia (5% off)" value="ARS 80.750" />
                </div>
              </div>
            </AnimatedSection>

            {/* Módulos 1 y 2 */}
            <AnimatedSection animation="fadeUp" delay={300}>
              <div className="bg-white rounded-xl p-7 border-4 border-white shadow-xl transform md:scale-105 h-full flex flex-col">
                <div className="flex items-center gap-2 mb-4 flex-wrap">
                  <div className="bg-gray-900 text-white text-xs font-bold py-1 px-3 rounded-full inline-block">
                    MÓDULOS 1 + 2
                  </div>
                  <span className="text-xs text-gray-700 font-semibold">de 9 a 17hs</span>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-1">Jornada Completa</h4>
                <p className="text-xs text-gray-500 mb-5">Incluye almuerzo</p>
                <div className="mt-auto space-y-1">
                  <div className="bg-gradient-to-r from-gray-800 to-gray-700 rounded-lg p-4 mb-3">
                    <p className="text-2xl font-black text-white">ARS 180.000</p>
                  </div>
                  <PriceRow label="Transferencia (5% off)" value="ARS 171.000" />
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* PACKS EQUIPO */}
          <AnimatedSection animation="fadeUp" delay={0}>
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3">
              <span className="bg-white/20 rounded-full w-8 h-8 flex items-center justify-center text-sm">2</span>
              Pack Equipo
            </h3>
          </AnimatedSection>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Pack 2 */}
            <AnimatedSection animation="fadeUp" delay={0}>
              <div className="bg-white rounded-xl p-8 h-full">
                <div className="bg-teal-600 text-white text-sm font-bold py-1 px-4 rounded-full inline-block mb-4">
                  PACK 2 PERSONAS
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-6">Pack Equipo — 2 personas</h4>
                <div className="space-y-1">
                  <PriceRow
                    label="Módulo 1 (incluye desayuno)"
                    value="ARS 195.000"
                    sub="Transferencia: ARS 185.250"
                  />
                  <PriceRow
                    label="Módulo 2"
                    value="ARS 150.000"
                    sub="Transferencia: ARS 142.500"
                  />
                  <div className="bg-teal-50 rounded-lg p-3 mt-3">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-semibold text-gray-700">Módulos 1 y 2 (incluye almuerzo)</span>
                      <div className="text-right">
                        <p className="font-black text-gray-900">ARS 330.000</p>
                        <p className="text-xs text-teal-600 font-medium">Transferencia: ARS 313.500</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AnimatedSection>

            {/* Pack 3 */}
            <AnimatedSection animation="fadeUp" delay={150}>
              <div className="bg-white rounded-xl p-8 h-full">
                <div className="bg-teal-600 text-white text-sm font-bold py-1 px-4 rounded-full inline-block mb-4">
                  PACK 3 PERSONAS
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-6">Pack Equipo — 3 personas</h4>
                <div className="space-y-1">
                  <PriceRow
                    label="Módulo 1 (incluye desayuno)"
                    value="ARS 300.000"
                    sub="Transferencia: ARS 285.000"
                  />
                  <PriceRow
                    label="Módulo 2"
                    value="ARS 240.000"
                    sub="Transferencia: ARS 228.000"
                  />
                  <div className="bg-teal-50 rounded-lg p-3 mt-3">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-semibold text-gray-700">Módulos 1 y 2 (incluye almuerzo)</span>
                      <div className="text-right">
                        <p className="font-black text-gray-900">ARS 525.000</p>
                        <p className="text-xs text-teal-600 font-medium">Transferencia: ARS 498.750</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AnimatedSection>
          </div>

          {/* Pack rules */}
          <AnimatedSection animation="fadeUp" delay={100}>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-8 border border-white/20">
              <h3 className="text-xl font-bold text-white mb-4">
                Reglas del pack
              </h3>
              <ul className="space-y-2 text-white">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-xl mt-0.5" />
                  <span>Un solo pagador.</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-xl mt-0.5" />
                  <span>Un solo comprobante.</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-xl mt-0.5" />
                  <span>Pasás nombres por WhatsApp.</span>
                </li>
              </ul>
            </div>
          </AnimatedSection>

          {/* Live indicator */}
          <div className="flex items-center justify-center gap-3 mb-8 bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 border border-white/20 max-w-md mx-auto">
            <div className="relative">
              <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse" />
              <div className="absolute inset-0 w-3 h-3 bg-red-500 rounded-full animate-ping" />
            </div>
            <p className="text-white font-medium text-sm">
              <span className="font-bold">{viewers}</span> personas viendo esta formación ahora
            </p>
          </div>

          <AnimatedSection animation="scaleUp" delay={200}>
            <div className="text-center">
              <a
                href={WA_PACK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-4 bg-white text-teal-600 rounded-lg font-semibold text-lg hover:bg-gray-100 hover:scale-110 transition-all duration-300 whitespace-nowrap cursor-pointer hover:shadow-2xl hover:shadow-white/50"
              >
                Quiero pack equipo
              </a>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
